import { useEffect, useState } from 'react';
import { themes as commonThemes } from '@sitebuilder/common';
import { CheckboxSwitch } from '../index';

const defaultColorOption = {
    id: '',
};

interface ColorVarSelectProps {
    value: string;
    colorKey: string;
    options: any;
    theme: any;
    showVarDropDown: boolean;
    onChangeShowVarOption: (value: any) => void;
    selectedColorVar: string;
    setSelectedColorVar: (value: any) => void;
    onChange: (value: any) => void;
}

const ColorVarSelect = (props: ColorVarSelectProps) => {
    const {
        colorKey,
        theme,
        options,
        showVarDropDown,
        onChangeShowVarOption,
        selectedColorVar,
        setSelectedColorVar,
        onChange,
    } = props;
    const [showVarOption, setShowVarOption] = useState(true);
    const [colorOptions, setColorOptions] = useState([
        defaultColorOption,
        ...Object.keys(commonThemes.defaultColors).map((key: any) => ({
            id: `${key}`,
        })),
    ]);

    useEffect(() => {
        if (options?.isCustomColor && theme?.colors) {
            const currColorIndex = Object.keys(theme.colors).findIndex((k) => k === colorKey);
            if (currColorIndex === 0) setShowVarOption(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options?.isCustomColor]);

    useEffect(() => {
        if (theme) {
            if (options?.isDefaultColor) {
                const _defaultColors = { ...commonThemes.defaultColors, ...theme?.defaultColors };
                const currColorIndex = Object.keys(_defaultColors).findIndex((k) => k === colorKey);
                const filteredDefaultColors = Object.fromEntries(
                    Object.entries(_defaultColors).filter((_obj, i) => i < currColorIndex)
                );
                setColorOptions([
                    defaultColorOption,
                    ...Object.keys({
                        ...theme?.colors,
                        ...filteredDefaultColors,
                    }).map((key: any) => ({
                        id: `${key}`,
                    })),
                ]);
            } else if (options?.isCustomColor && theme?.colors) {
                const currColorIndex = Object.keys(theme.colors).findIndex((k) => k === colorKey);
                const filteredColors = Object.fromEntries(
                    Object.entries(theme.colors).filter((_obj, i) => i < currColorIndex)
                );
                setColorOptions([
                    defaultColorOption,
                    ...Object.keys({
                        ...filteredColors,
                    }).map((key: any) => ({
                        id: `${key}`,
                    })),
                ]);
            } else {
                setColorOptions([
                    defaultColorOption,
                    ...Object.keys({
                        ...theme?.colors,
                        ...commonThemes.defaultColors,
                        ...theme?.defaultColors,
                    }).map((key: any) => ({
                        id: `${key}`,
                    })),
                ]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme]);

    const onSelectColorVar = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const colorVar = `var(${e.target.value})`;
        setSelectedColorVar(e.target.value);
        onChange(colorVar);
    };

    return (
        <div className="color-var-select">
            {showVarOption && (
                <CheckboxSwitch
                    title="Use Theme Variables"
                    checked={showVarDropDown}
                    onChange={onChangeShowVarOption}
                />
            )}
            {showVarDropDown && (
                <div className="custom-select">
                    <label className="select-label">Select Theme Variable</label>
                    <select
                        id={'themeColorSelect'}
                        className="custom-select-input"
                        data-testid="select"
                        onChange={onSelectColorVar}
                        defaultValue={selectedColorVar}
                    >
                        {colorOptions.map((key: any, i: number) => (
                            <option
                                data-testid="select-option"
                                key={`${key.id}-${i}`}
                                id={key.id}
                                value={key.id}
                            >
                                {key.id}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

export default ColorVarSelect;
